import { Component, OnInit, Input, AfterViewInit, forwardRef, ViewChild, ElementRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'ngx-cm-checkbox',
  templateUrl: './ngx-cm-checkbox.component.html',
  styleUrls: ['./ngx-cm-checkbox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NgxCmCheckboxComponent),
      multi: true
    }
  ]
})
export class NgxCmCheckboxComponent implements AfterViewInit, ControlValueAccessor {
  @Input()
  IsRadio = false;

  @Input()
  Name;

  @Input()
  Value = 'true';

  @ViewChild('chk', { static: false }) chk: ElementRef;

  contextValue;
  public onChange;

  constructor() { }

  ngAfterViewInit() {
  }

  registerOnChange(fn) {
    this.onChange = fn;
  }

  registerOnTouched(fn) { }

  writeValue(value) {
    this.contextValue = value;
  }

  updateValue(checked) {
    if (!checked) {
      this.chk.nativeElement.checked = true;
      this.contextValue = this.Value;
      if (this.onChange) {
        this.onChange(this.Value);
      }
    } else {
      this.chk.nativeElement.checked = false;
      this.contextValue = null;
      if (this.onChange) {
        this.onChange(null);
      }
    }
  }
}
